module.exports = __webpack_public_path__ + "img/btn_auto_spin.961b6227.png";